import '../list/gb-list.tag.html';
import './gb-sayt-link.tag.html';
import '../raw/gb-raw.tag.html';
riot.tag2('gb-sayt-search-terms', '<gb-list items="{_scope.queries}"> <gb-sayt-link send="{_scope.search}" data-value="{item.value}"> <yield> <gb-raw content="{_scope.highlightCurrentQuery(item.value, \'<b>$&</b>\')}"></gb-raw> </yield> </gb-sayt-link> </gb-list>', '', '', function(opts) {

    this._scopeTo('gb-sayt');
});



/** WEBPACK FOOTER **
 ** ./src/tags/sayt/gb-sayt-search-terms.tag.html
 **/